// extracted by mini-css-extract-plugin
export default {"containerCards":"Cards_containerCards__N3Ut9"};